module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"emptyErrorMessage":"Wert darf nicht leer sein","notANumberErrorMessage":"{text} ist keine Zahl","notAnIntegerErrorMessage":"Wert muss eine Ganzzahl sein","tooSmallErrorMessage":"Wert darf nicht kleiner als {min} sein","tooLargeErrorMessage":"Wert darf nicht grösser als {max} sein"}}')
  delete Component.options._Ctor
}
